import React from 'react'
import Hero from './component/Hero'
import Aboutus from './component/Aboutus'
import Portfolio from './component/Portfolio'
import Apart from './component/Apart'
import { Box } from '@chakra-ui/react'
import Trusted from './component/Trusted'
import Success from '../home/component/Success'
import Footer from '../header/Footer'
import Successstories from 'component/home/component/Successstories'
import useScrollAnimation from 'component/useScrollAnimation'

const About = () => {
  useScrollAnimation();
  return (
    <>
    <Box bg="#f4eddc" fontFamily={'Archivo'}>
    <Hero/>
    <Aboutus/>
    <Portfolio/>
    <Apart/>
    <Successstories/>
    <Trusted/>
    <Success/>
    </Box>
    <Footer/>
    </>
  )
}

export default About